<template>
  <component :is="currentComponent" :key="deviceClass" :detail="detail" />
</template>

<script>
import pcContent from '@/components/ModelFour/pcContent.vue'
import h5Content from '@/components/ModelFour/h5Content.vue'
export default {
  components: { pcContent, h5Content },
  name: 'pageModel4',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    currentComponent() {
      return this.deviceClass == 'pc' ? 'pcContent' : 'h5Content'
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  created() {},
  methods: {},
}
</script>
